'use strict';

const jQuery = require('jquery');
const Translator = require('./../../../../../core/translator');

const tplProtocolElement = require('./../template/protocol_element.hbs');
const regex = /^(http[s]?:\/\/|\/)(.*)$/;

module.exports.getValues = function() {
  return {
    '/': Translator.translate('yaml_element_url_internal'),
    'https://': Translator.translate('yaml_element_url_https'),
    'http://': Translator.translate('yaml_element_url_http'),
  };
};

module.exports.getDefaultValue = function() {
  return '/';
};

module.exports.getValue = function(url) {
  return url ? (url.match(regex) || 'internal')[1] : 'internal';
};

module.exports.getURLValue = function(url) {
  return url ? (url.match(regex) || '')[2] : '';
};

module.exports.getTemplate = function(value) {
  return jQuery(tplProtocolElement({
    'values': this.getValues(),
    'value': value || this.getDefaultValue(),
  }));
};
